import { DownloadSource } from "..";
import { FileHeader } from "../../../domain/file";
import { DateTimeConverter } from "../../utilities";
import { IFileHeaderBean } from "../beans";

export class FileTranslators {
  static toFileHeader(getToken: () => string, folderGuid: string, bean: IFileHeaderBean): FileHeader {
    if (!bean) { throw new Error("bean is empty!!!"); }
    
    const result = new FileHeader();
    result.id = bean.id;
    result.name = bean.name;
    result.size = bean.size;
    result.createDateTime = DateTimeConverter.toDate(bean.createDateTime);
    result.createUserCode = bean.createUserCode;
    result.source = new DownloadSource(getToken, folderGuid, bean.id);
    return result;
  }
}
